module.exports = __webpack_public_path__ + "img/AgenciaVirtual.beb54c13.png";